import { render, staticRenderFns } from "./SupplierCreateModal.vue?vue&type=template&id=1936d5ca&scoped=true"
import script from "./SupplierCreateModal.vue?vue&type=script&lang=js"
export * from "./SupplierCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1936d5ca",
  null
  
)

export default component.exports